<template>
  <div class="basic_wrap">
    
    <!-- ================= 顶部蓝色统计卡片 ================= -->
    <div class="header_blue_bg">
      <div class="header_top">
        <div class="back_btn" @click="$router.back()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </div>
        <div class="header_title">{{ $t('withdraw.withdrawRecord') }}</div>
      </div>
      
      <div class="stat_cards">
        <div class="stat_card">
          <div class="stat_label">{{ $t('utils.msg14') || '提现次数' }}</div>
          <div class="stat_value">{{ list.length }}</div>
        </div>
        <div class="stat_card">
          <div class="stat_label">{{ $t('utils.msg13') || '累计提现' }}</div>
          <div class="stat_value">{{ currency_symbol_basic }}{{ withdraw_money }}</div>
        </div>
      </div>
    </div>

    <div class="item_wrap">
      <div class="list_header_title">{{ $t('withdraw.withdrawRecord') }}</div>
      
      <div class="item_list">
        <van-list
          v-model="loading"
          loading-text=" "
          offset="0"
          :finished="finished"
          :finished-text="$t('utils.noData')"
          @load="onLoad"
        >
          <!-- 单条记录卡片 -->
          <div v-for="(item,index) in list" class="card_box item" :key="index">
            
            <!-- 头部：银行信息 + 状态 -->
            <div class="card_header">
              <div class="bank_info">
                <!-- 这里使用默认银行图标，如果有接口返回图标字段，可把 src 换成 item.bank_icon -->
                <img class="bank_icon" :src="logo" alt="bank">
                <div class="bank_text">
                  <div class="bank_name">{{ item.bank_name }}</div>
                  <div class="bank_account" >{{ item.account ? item.account : '12******1321' }}</div>
                </div>
              </div>
              <span class="status_tag" :class="{'status_done': item.status==1, 'status_pending': [0,3,4].includes(item.status), 'status_fail': item.status==2}">
                <span v-if="item.status==1">{{ $t('tabs.done') }}</span>
                <span v-else-if="[0,3,4].includes(item.status)">{{ $t('tabs.pending') }}</span>
                <span v-else-if="item.status==2">{{ $t('tabs.fail') }}</span>
              </span>
            </div>

            <!-- 2x2 数据网格 -->
            <div class="data_grid">
              <div class="grid_item">
                <div class="g_label">{{ $t('utils.lunlog54') }}</div>
                <div class="g_val green">{{ currency_symbol_basic }}{{ precision_basic(item.money) }}</div>
              </div>
              <div class="grid_item">
                <div class="g_label">{{ $t('utils.lunlog55') }}</div>
                <div class="g_val green">{{ currency_symbol_basic }}{{ precision_basic(item.money2) }}</div>
              </div>
              <div class="grid_item">
                <div class="g_label">{{ $t('utils.lunlog51') }}</div>
                <div class="g_val gray">{{ item.act_time }}</div>
              </div>
              <div class="grid_item">
                <div class="g_label">{{ $t('utils.lunlog52') }}</div>
                <div class="g_val gray">{{ item.time_audit || '--' }}</div>
              </div>
            </div>

            <!-- 失败提示语 -->
            <div v-if="item.status==2" class="fail_tips">
              {{ $t('withdraw.withdrawFailTips') }}
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { List } from 'vant';
Vue.use(List);

export default {
  name: "WithdrawRecord",
  components: { bsHeader },
  data() {
    return {
      currency_symbol_basic: localStorage.getItem('currency_symbol_basic'),
      data: [],
      empty: false,
      loading: false,
      finished: false,
      list: [],
	  logo:'',
      total_money: 0, // 累计提现
	  withdraw_money:9,
      page: 1,
      listRows: 8
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    // 初始化时先统计列表中的金额
    this.calcTotal();
  },
  methods: {
    precision(money) {
      var precision = localStorage.getItem('precision');
      return (money / 1).toFixed(precision);
    },
    precision_basic(money) {
      var precision = localStorage.getItem('precision_basic');
      return (money / 1).toFixed(precision);
    },
    // 实时计算累计提现
    calcTotal() {
      let sum = 0;
      this.list.forEach(item => {
        sum += parseFloat(item.money);
      });
      this.total_money = sum.toFixed(2);
    },
    onLoad() {
      Fetch('/user/withdrawRecord', {
        page: this.page,
        listRows: this.listRows
      }).then(r => {
        if (r.data.length == 0) this.empty = true;
		this.logo=r.data.logo;
		this.withdraw_money=r.data.withdraw_money;
        var list = r.data.list;
        for (var i = 0; i < list.length; i++) {
          this.list.push(list[i]);
        }
        // 每次加载完重新计算总提现额
        this.calcTotal();
        
        if (this.list.length >= r.data.length) {
          this.finished = true;
          return;
        }
        this.page = this.page + 1;
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  padding-bottom: 60px;
  min-height: 100vh;
  /* 浅蓝网格背景 */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

/* ================= 顶部蓝色统计卡片 ================= */
.header_blue_bg {
  background: linear-gradient(135deg, #4f8cf7, #3570e6);
  border-radius: 0 0 24px 24px;
  padding: 16px 20px 24px;
  margin-bottom: 10px;

  .header_top {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .back_btn {
      width: 32px; height: 32px;
      background: rgba(255,255,255,0.2);
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      cursor: pointer;
      margin-right: 12px;
      svg { width: 18px; height: 18px; }
    }
    .header_title {
      font-size: 18px; font-weight: 700; color: #fff;
    }
  }

  .stat_cards {
    display: flex; gap: 16px;
    .stat_card {
      flex: 1;
      background: rgba(255,255,255,0.15);
      border-radius: 12px;
      padding: 12px 0;
      text-align: center;
      .stat_label { font-size: 12px; color: rgba(255,255,255,0.8); margin-bottom: 4px; }
      .stat_value { font-size: 18px; font-weight: 700; color: #fff; }
    }
  }
}

/* ================= 列表标题 ================= */
.list_header_title {
  font-size: 16px; font-weight: 700; color: #111;
  padding: 0 16px; margin-bottom: 12px;
}

.item_wrap {
  width: 100%;
  padding: 0 0 20px 0;

  .item_list {
    padding: 0 16px;

    .card_box.item {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
      border: 1px solid rgba(176, 202, 240, 0.3);

      /* 1. 卡片头部：银行 + 状态标签 */
      .card_header {
        display: flex; justify-content: space-between; align-items: center;
        margin-bottom: 16px;
        border-bottom: 1px solid #f1f5f9;
        padding-bottom: 12px;

        .bank_info {
          display: flex; align-items: center; gap: 12px;
          .bank_icon {
            width: 36px; height: 36px;
            border-radius: 50%; object-fit: cover;
            background: #f0f4fa;
          }
          .bank_text {
            display: flex; flex-direction: column;
            .bank_name { font-size: 14px; font-weight: 600; color: #111; }
            .bank_account { font-size: 12px; color: #64748b;line-height: 18px; }
          }
        }

        .status_tag {
          display: inline-block; padding: 3px 12px;
          border-radius: 12px; font-size: 12px; font-weight: 600;
          &.status_done { background: #dcfce7; color: #16a34a; }
          &.status_pending { background: #fef9c3; color: #a16207; }
          &.status_fail { background: #fee2e2; color: #dc2626; }
        }
      }

      /* 2. 2x2 数据网格 */
      .data_grid {
        display: grid; grid-template-columns: 1fr 1fr; gap: 12px;
        .grid_item {
          .g_label { font-size: 12px; color: #64748b; margin-bottom: 4px; }
          .g_val { font-size: 15px; font-weight: 700; 
            &.green { color: #16a34a; }
            &.gray { color: #475569; font-weight: 500; }
          }
        }
      }

      /* 3. 失败提示 */
      .fail_tips {
        margin-top: 12px; padding-top: 10px;
        border-top: 1px solid #fee2e2;
        color: #dc2626; font-size: 13px;
        font-weight: 500;
      }
    }
  }
}
</style>